import { IAction } from '../../../__core/Interfaces/IAction';
import { CourseVersionsResponse } from '../Types/CourseVersionsResponse';
import { IDirectAccessReducer } from '../Interfaces/IDirectAccessReducer';
import { directAccessInitState } from './DirectAccessInitState';
import { courseVersionsReducer } from './CourseVersions';
import { DirectAccessCourseResponse } from '../Types/DirectAccessCourseResponse';
import { directAccessCourseReducer } from './Course';

type DirectAccessReducerAction =
  | IAction<CourseVersionsResponse>
  | IAction<DirectAccessCourseResponse>;

export const directAccessReducer = (
  state: IDirectAccessReducer = directAccessInitState,
  action: DirectAccessReducerAction
): IDirectAccessReducer => {
  return {
    courseVersions: courseVersionsReducer(
      state.courseVersions,
      action as IAction<CourseVersionsResponse>
    ),
    courseDetails: directAccessCourseReducer(
      state.courseDetails,
      action as IAction<DirectAccessCourseResponse>
    ),
  };
};
